import callAPI from "config/callAPI";
import PortalAuth from "config/auth/PortalAuth";
import { sanitizeDateParameter, sanitizeNumericParameter, setPortalActiveMenu } from "libraries/common_functions";

import React from "react";
import dateFormat from "dateformat";

import PortalHeader from "pages/portal/includes/PortalHeader";
import PortalMobileMenu from "pages/portal/includes/PortalMobileMenu";
import PortalTopMenu from "pages/portal/includes/PortalTopMenu";
import PortalFooter from "pages/portal/includes/PortalFooter";

const UTILITIES_ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/portal_utilities';
const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/get_campaign';

class PortalAnalytics extends React.Component {
    constructor(){
        super();

        this.state = {
            isloggedin: false,
            alertColor: '',
            campaign: '',
            start_date: '',
            end_date: '',
            rstatus: '',
            rmessage: '',
            rdata: []
        }

        let isloggedinPromise = PortalAuth();
        
        isloggedinPromise.then((isloggedin) => {
            this.setState({isloggedin: isloggedin});
        });
    }

    async getCampaignTrackingData(){
        const location = window.location;
        const queryParams = new URLSearchParams(location.search);

        var campaign = sanitizeNumericParameter(queryParams.get('campaign'));
        var start_date = sanitizeDateParameter(queryParams.get('start_date'));
        var end_date = sanitizeDateParameter(queryParams.get('end_date'));

        if (location.search !== ''){
            this.setState({campaign: campaign});
            this.setState({start_date: start_date});
            this.setState({end_date: end_date});

            var data = {campaign: campaign, start_date: start_date, end_date: end_date};

            const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data);
            this.setState({
                rstatus: rstatus,
                rmessage: rmessage,
                rdata: rdata
            });

            if (rstatus === true){ 
                this.setState({alertColor: 'green'}); 
            } 
            else if (rstatus === false) { 
                this.setState({alertColor: 'red'}); 
            }
        }
    }

    async getCampaigns(){
        var data = {action:  'get_campaigns'};

         // eslint-disable-next-line
        const {rstatus, rmessage, rdata } = await callAPI(UTILITIES_ENDPOINT, data);
        if (rstatus === true){ 
            var campaignSelect = document.getElementsByName('campaign')[0];
            if (rdata.campaigns.length > 0){ 
				for (var i=0; i<rdata.campaigns.length; i++){
					campaignSelect.options.add(new Option(rdata.campaigns[i].campaign_name, rdata.campaigns[i].campaign_id));
                    campaignSelect.options[i+1].selected = rdata.campaigns[i].campaign_id === parseInt(this.state.campaign); 
				}
            }
        } 
    }

    componentDidMount(){
        setPortalActiveMenu('analytics');

        this.getCampaignTrackingData();
        this.getCampaigns();
    }

    render() {
        if (!this.state.isloggedin){
            return (<></>);
        }

        return (
            <>
                <PortalMobileMenu />

                <div className="flex">
                    
                    <PortalHeader />
                        
                    <div className="content">
                            
                        <PortalTopMenu page_name="Analytics" />

                        <div className="intro-y flex items-center mt-8">
                            <h2 className="text-lg font-medium mr-auto">
                                Analytics
                            </h2>
                        </div>

                        <div className="grid grid-cols-12 gap-6 mt-5">
                            <div className="intro-y col-span-12 lg:col-span-12">
                                <div className="intro-y box mt-5">
                                    <div className="p-5" id="horizontal-form">
                                        <form className="preview" method="get">
                                            <div className="flex flex-col sm:flex-row items-center mt-3">
                                                <div className="w-full xl:w-1/3 md:w-1/3 sm:w-1/3 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Campaign Name</label>
                                                    <select name="campaign" className="input w-full border mt-2 flex-1" defaultValue="" >
                                                        <option value="">Select a campaign</option>
                                                    </select>
                                                </div>
                                                <div className="w-full xl:w-1/3 md:w-1/3 sm:w-1/3 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Start Date</label>
                                                    <input type="text" name="start_date" defaultValue={this.state.start_date} className="datepicker input w-full border mt-2 flex-1" data-single-mode="true" />
                                                </div>
                                                <div className="w-full xl:w-1/3 md:w-1/3 sm:w-1/3 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">End Date</label>
                                                    <input type="text" name="end_date" defaultValue={this.state.end_date} className="datepicker input w-full border mt-2 flex-1" data-single-mode="true" />
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-center mt-5">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5">
                                                    <button type="submit" className="button bg-theme-3 text-white w-1/4">Get</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        { this.state.rstatus !== "" ?

                        <div className="grid grid-cols-12 gap-6 mt-5">
                            <div className="intro-y col-span-12 lg:col-span-12">
                                <div className="intro-y box mt-5">

                                { this.state.rstatus === true ?

                                    <div className="p-5" id="horizontal-form">
                                        <div className="preview">

                                            <div className="flex flex-col sm:flex-row items-center">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-1/2 sm:w-20 sm:text-right mr-3">Campaign Name :</label>
                                                    <label className="w-1/2 mt-2 flex-1" style={{color: 'grey'}}>{this.state.rdata.campaign_data.campaign_name}</label>
                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-1/2 sm:w-20 sm:text-right mr-3">Link Created :</label>
                                                    <label className="w-1/2 mt-2 flex-1" style={{color: 'grey'}}>{dateFormat(this.state.rdata.campaign_data.date_created, "dddd, mmmm dS, yyyy")}</label>
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-center">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-1/2 sm:w-20 sm:text-right mr-3">UTM Source :</label>
                                                    <label className="w-1/2 mt-2 flex-1">{this.state.rdata.campaign_data.utm_source}</label>
                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-1/2 sm:w-20 sm:text-right mr-3">Total Clicks :</label>
                                                    <label className="w-1/2 mt-2 flex-1" style={{color: this.state.alertColor}}>{this.state.rdata.total_link_clicks}</label>
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-10">
                                                    <h3 className="w-full sm:mr-5" style={{fontSize: "1rem"}}>Link Clicked by Location</h3>
                                                    <hr className="border mt-2 mb-2"></hr>
                                                    
                                                    { this.state.rdata.total_link_clicks_by_location.length > 0 ?

                                                        this.state.rdata.total_link_clicks_by_location.map(function(clicks_by_location, i){

                                                            return (
                                                                <React.Fragment key={`${i+1}`}>
                                                                    <div className="w-full">
                                                                        <label className="w-3/4 text-left" style={{display: "inline-block"}}>{clicks_by_location.location}</label>
                                                                        <label className="w-1/4 text-left" style={{display: "inline-block", color: "green"}}>{clicks_by_location.link_clicked}</label>
                                                                    </div>
                                                                </React.Fragment>
                                                            )

                                                        })

                                                        :

                                                        <p style={{ color: "red", paddingTop: 2}}>
                                                            There is no data to show!
                                                        </p>

                                                    }

                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-10">
                                                    <h3 className="w-full sm:mr-5" style={{fontSize: "1rem"}}>Link Clicked by Devices</h3>
                                                    <hr className="border mt-2 mb-2"></hr>
                                                    
                                                    { this.state.rdata.total_link_clicks_by_device.length > 0 ?

                                                        this.state.rdata.total_link_clicks_by_device.map(function(clicks_by_device, i){

                                                            return (
                                                                <React.Fragment key={`${i+1}`}>
                                                                    <div className="w-full">
                                                                        <label className="w-1/3 text-left" style={{display: "inline-block"}}>{clicks_by_device.device_name}</label>
                                                                        <label className="w-1/3 text-left" style={{display: "inline-block"}}>{clicks_by_device.device}</label>
                                                                        <label className="w-1/3 text-left" style={{display: "inline-block", color: "green"}}>{clicks_by_device.link_clicked}</label>
                                                                    </div>
                                                                </React.Fragment>
                                                            )

                                                        })

                                                        :

                                                        <p style={{ color: "red", paddingTop: 2}}>
                                                            There is no data to show!
                                                        </p>

                                                    }
                                                
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                :

                                <p style={{ color: this.state.alertColor, padding: "10px"}}>
                                    {this.state.rmessage}
                                </p>

                                }
                                    
                                </div>
                            </div>
                        </div>

                        :

                            ""
                        }
                        
                    </div>
                </div>

                <PortalFooter />
            </>
        );
    }
}

export default PortalAnalytics;
